import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { getStoredCompany } from '../utils/certificate';

export const AonBackBar = ({ isAuthenticated, corporate }) => {
  const { pathname } = useLocation();
  const company = getStoredCompany();
  if (!pathname.startsWith('/learning-path/english-language') || company?.theme !== 'teal' || !company?.linkId) return null;
  if (isAuthenticated && corporate) return null;
  return (
    <div className="bg-teal-300 border-t border-teal-500" data-testid="aon-back-bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex justify-center">
        <Link to={`/corporate/aon/${company.linkId}`} data-testid="aon-back-button"
          className="inline-flex items-center gap-3 text-[#0a0a0a] text-base sm:text-lg hover:gap-4 transition-[gap] duration-200">
          <ArrowLeft className="w-5 h-5" /> Back to Trivium for AON
        </Link>
      </div>
    </div>
  );
};
